import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { truncateString } from 'utils/helpers/string';

import { ProgramProps } from 'pages/ContentLibrary/types';

import * as S from './styles';

const ProgramCard: React.FC<ProgramProps> = ({
  id,
  titleKey,
  description,
  createdAt,
  programTopics,
}) => {
  const navigate = useNavigate();

  const handleProgramNavigation = (programId: number) => {
    navigate(`/content-library/programs/${programId}`);
  };

  const isProgramOld = (date: string, days: number) => {
    const programDate = new Date(date);
    const currentDate = new Date();
    const difference = currentDate.getTime() - programDate.getTime();
    const daysDifference = Math.ceil(difference / (1000 * 3600 * 24));

    return daysDifference < days;
  };

  return (
    <S.Container
      data-testid="programCardContainer"
      onClick={() => handleProgramNavigation(id)}
    >
      <S.MainContent>
        <S.Title>{truncateString(titleKey, 60)}</S.Title>

        <S.Description>{description}</S.Description>
      </S.MainContent>

      <S.Footer>
        <S.ModulesCount>
          {programTopics.length}{' '}
          <FormattedMessage
            id={`CONTENT_LIBRARY.MODULES.${
              programTopics.length > 1 ? 'OTHERS' : 'ONE'
            }`}
          />
        </S.ModulesCount>
        {isProgramOld(createdAt, 30) && (
          <S.Label>
            <FormattedMessage id="CONTENT_LIBRARY.NEW" />
          </S.Label>
        )}
      </S.Footer>
    </S.Container>
  );
};

export default ProgramCard;
